import React from 'react';
import PropTypes from 'prop-types';
import style from './Grid.scss';

const Grid = ({ children, fluid, className, ...props }) => {
	const containerClass = fluid ? style.containerFluid : style.container;
	const classes = className ? `${containerClass} ${className}` : containerClass;

	return (
		<div {...props} className={classes}>
			{children}
		</div>
	);
};

Grid.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	fluid: PropTypes.bool,
};

export default Grid;
